import React, { FC } from 'react'
import { HandleBusinessTimeType } from 'types/store'
import { Spacer } from 'components/Utility'
import { ErrorMessage } from 'components/Error'
import { parseToCircleNumber } from 'lib/helper'
import { DayOfWeekType } from 'lib/daysOfWeek'

type Props = {
  businessTimes: HandleBusinessTimeType[]
  remainingDaysOfWeek: DayOfWeekType[]
}

const StoreSettingError: FC<Props> = (props) => {
  const { businessTimes, remainingDaysOfWeek } = props

  return (
    <>
      {remainingDaysOfWeek.length !== 0 && (
        <>
          <ErrorMessage
            caution={`未選択の曜日があります。営業日または定休日としてすべての曜日を選択してください`}
            id={'day-of-week'}
          />
          <Spacer size={12} />
        </>
      )}
      {businessTimes.map((businessTime, index) => (
        <div key={index.toString()}>
          {businessTime['order_start_time'] === '' && (
            <>
              <ErrorMessage
                caution={`営業時間${parseToCircleNumber(index + 1)}のオーダー開始時刻を入力してください。`}
                id={`order-start-time-${index + 1}`}
              />
              <Spacer size={12} />
            </>
          )}
          {businessTime['open_time'] === '' && (
            <>
              <ErrorMessage
                caution={`営業時間${parseToCircleNumber(index + 1)}の店舗オープン時刻を入力してください。`}
                id={`open-time-${index + 1}`}
              />
              <Spacer size={12} />
            </>
          )}
          {businessTime['last_order_time'] === '' && (
            <>
              <ErrorMessage
                caution={`営業時間${parseToCircleNumber(index + 1)}のラストオーダー時刻を入力してください。`}
                id={`last-order-time-${index + 1}`}
              />
              <Spacer size={12} />
            </>
          )}
          {businessTime['last_pickup_time'] === '' && (
            <>
              <ErrorMessage
                caution={`営業時間${parseToCircleNumber(index + 1)}の最終受渡時刻を入力してください。`}
                id={`last-pickup-time-${index + 1}`}
              />
              <Spacer size={12} />
            </>
          )}
        </div>
      ))}
    </>
  )
}

export default StoreSettingError
